import { defineComponent, createBlock, openBlock, resolveDynamicComponent, mergeProps, withCtx, createCommentVNode, createElementVNode, createElementBlock, toDisplayString, normalizeStyle, createVNode } from 'vue';
import _sfc_main$3 from './basler-components.es79.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es112.js';
/* empty css                        */
import _sfc_main$1 from './basler-components.es121.js';

const _hoisted_1 = { class: "tag-list-item__content" };
const _hoisted_2 = { class: "tag-list-item__text-wrapper" };
const _hoisted_3 = { class: "tag-list-item__text" };
const defaultIconSale = 1.2;
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TagListItem",
  props: {
    tag: {},
    element: { default: "span" },
    isSmall: { type: Boolean, default: false }
  },
  emits: ["click", "close"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const handleClick = (event) => {
      const closeIcon = event.currentTarget?.querySelector(".tag-list-item__close-icon");
      const isCloseIconClick = closeIcon?.contains(event.target);
      if (!isCloseIconClick) {
        emit("click");
      }
    };
    const handleCloseClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (props.tag.link) {
        emit("close");
      } else {
        emit("click");
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.tag.link ? _sfc_main$1 : _ctx.element), mergeProps(_ctx.tag.link ? _ctx.tag.link : {}, {
        class: "tag-list-item",
        "data-tag-id": _ctx.tag.id ? _ctx.tag.id : void 0,
        type: _ctx.element === "button" ? "button" : void 0,
        onClick: handleClick
      }), {
        default: withCtx(() => [
          _ctx.tag.image ? (openBlock(), createBlock(_sfc_main$2, {
            key: 0,
            media: _ctx.tag.image,
            cols: [4, 6, 10],
            lazyload: true,
            class: "tag-list-item__image"
          }, null, 8, ["media"])) : createCommentVNode("", true),
          createElementVNode("span", _hoisted_1, [
            _ctx.tag.iconName ? (openBlock(), createBlock(_sfc_main$3, {
              key: 0,
              name: _ctx.tag.iconName,
              "scale-factor": _ctx.tag.iconScale || defaultIconSale,
              class: "tag-list-item__icon"
            }, null, 8, ["name", "scale-factor"])) : createCommentVNode("", true),
            createElementVNode("span", _hoisted_2, [
              createElementVNode("span", _hoisted_3, toDisplayString(_ctx.tag.text), 1)
            ]),
            _ctx.tag.showCloseIcon ? (openBlock(), createElementBlock("span", {
              key: 1,
              class: "tag-list-item__close-icon",
              style: normalizeStyle(`--close-icon-width: ${_ctx.tag.closeIconScaleFactor || 0.8}em`),
              onClick: handleCloseClick
            }, [
              createVNode(_sfc_main$3, {
                name: _ctx.tag.closeIconName || "close"
              }, null, 8, ["name"])
            ], 4)) : createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 16, ["data-tag-id", "type"]);
    };
  }
});

export { _sfc_main as default };
